module.exports = __webpack_public_path__ + "img/ZJ5338.48b6c40f.png";